import Component from './Component';
import normalizeNode from './normalizeNode';
import onKeyDown from './onKeyDown';
import operations from './operations';
import { deserialize, serialize } from './serialize';
import { type, isImage, toInline } from './shared';
import slashMenu from './slashMenu';

export default {
  Component,
  deserialize,
  is: isImage,
  isImage,
  isVoid: true,
  normalizeNode,
  onKeyDown,
  operations,
  serialize,
  slashMenu,
  toInline,
  type,
};
